const program = {

    // headings
    create: 'Create Company',
    edit: 'Edit Company',

    // List
    companyList: 'Company List',
    searchCriteria: 'Filter Preset',
    postalCode: 'Postal Code',
    presetName: 'Enter Preset Name',
    action: 'Action',

    // Tabs
    tabGeneral: 'General',
    tabAudit: 'Audit Log',

    // Labels
    companyName: 'Company Name',
    department: 'Department',
    contactPerson: 'Contact Person',
    title: 'Title',
    firstName: 'First Name',
    lastName: 'Last Name',
    streetAddress: 'Street Address',
    city: 'City',
    zip: 'Zip',
    country: 'Country',
    phone: 'Phone',
    mobile: 'Mobile',
    fax: 'Fax',
    email: 'Email',
    email2: 'Email 2',
    email3: 'Email 3',
    webAddress: 'Web Address',
    notes: 'Notes',
};

export default program;